var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.26 5.22014H15.2999M12.7799 2.7002V7.74009",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28233 13.7249C4.46328 13.6443 3.8497 13.3983 3.43821 12.9868C2.70013 12.2487 2.70013 11.0608 2.70013 8.68496V8.36997C2.70013 5.99414 2.70013 4.80623 3.43821 4.06815C4.17629 3.33008 5.3642 3.33008 7.74003 3.33008H8.68501M5.53507 12.7799C5.40564 13.4111 4.82803 14.7747 5.41896 15.2148C5.72785 15.4396 6.22005 15.1995 7.20446 14.7195C7.89532 14.3826 8.59441 13.9963 9.34939 13.8225C9.62564 13.7596 9.90687 13.7327 10.26 13.7249C12.6358 13.7249 13.8237 13.7249 14.5618 12.9868C15.2665 12.2821 15.2984 11.1673 15.2998 8.99996",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add_comment.a90c765c4274fece7f137f5b94171db0.svg";
export { ForwardRef as ReactComponent };